export default "__VITE_ASSET__1f7c575d__"